<template>
  <svg
    v-if="dataFound"
    :class="$style.svgBox"
    data-testid="svgBox"
    viewBox="0 0 339 94"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :class="$style.chartPolygon"
      data-testid="chartPolygon"
      opacity="0.2"
      d="M170.921 1C250.489 1 261.889 77.405 321 90.7909C326.498 92.036 338.826 92.7783 338.826 92.7783H0C0 92.7783 7.53339 92.5287 11.0596 92.0556C75.156 83.4561 88.4876 1 170.921 1Z"
    />
    <path
      :class="$style.chartCurve"
      data-testid="curveChart"
      d="M0 93C74 93 83.5 1 169.5 1C255.5 1 265 93 339 93"
    />
    <path
      d="M221.034 62.396V63.14H219.894V65H219.054V63.14H215.118V62.528L218.61 57.104H219.534L216.126 62.396H219.054V60.476L219.894 60.296V62.396H221.034ZM224.933 65.168C223.001 65.168 222.029 63.62 222.029 61.052C222.029 58.484 223.001 56.936 224.933 56.936C226.829 56.936 227.813 58.484 227.813 61.052C227.813 63.62 226.829 65.168 224.933 65.168ZM224.933 64.388C226.289 64.388 226.925 63.212 226.925 61.052C226.925 58.904 226.289 57.716 224.933 57.716C223.577 57.716 222.917 58.904 222.917 61.052C222.917 63.212 223.577 64.388 224.933 64.388ZM234.007 61.268C232.771 61.268 231.919 60.392 231.919 59.108C231.919 57.824 232.771 56.936 234.007 56.936C235.255 56.936 236.107 57.812 236.107 59.096C236.107 60.38 235.255 61.268 234.007 61.268ZM233.875 65L238.711 57.104H239.563L234.727 65H233.875ZM234.007 60.56C234.763 60.56 235.303 59.936 235.303 59.096C235.303 58.256 234.763 57.644 234.007 57.644C233.263 57.644 232.723 58.268 232.723 59.108C232.723 59.948 233.263 60.56 234.007 60.56ZM239.407 65.168C238.171 65.168 237.319 64.292 237.319 63.008C237.319 61.724 238.171 60.836 239.407 60.836C240.655 60.836 241.507 61.712 241.507 62.996C241.507 64.28 240.655 65.168 239.407 65.168ZM239.407 64.46C240.163 64.46 240.715 63.848 240.715 62.996C240.715 62.156 240.163 61.544 239.407 61.544C238.663 61.544 238.111 62.156 238.111 63.008C238.111 63.848 238.663 64.46 239.407 64.46Z"
      fill="black"
    />
    <path
      d="M108.034 62.396V63.14H106.894V65H106.054V63.14H102.118V62.528L105.61 57.104H106.534L103.126 62.396H106.054V60.476L106.894 60.296V62.396H108.034ZM111.933 65.168C110.001 65.168 109.029 63.62 109.029 61.052C109.029 58.484 110.001 56.936 111.933 56.936C113.829 56.936 114.813 58.484 114.813 61.052C114.813 63.62 113.829 65.168 111.933 65.168ZM111.933 64.388C113.289 64.388 113.925 63.212 113.925 61.052C113.925 58.904 113.289 57.716 111.933 57.716C110.577 57.716 109.917 58.904 109.917 61.052C109.917 63.212 110.577 64.388 111.933 64.388ZM121.007 61.268C119.771 61.268 118.919 60.392 118.919 59.108C118.919 57.824 119.771 56.936 121.007 56.936C122.255 56.936 123.107 57.812 123.107 59.096C123.107 60.38 122.255 61.268 121.007 61.268ZM120.875 65L125.711 57.104H126.563L121.727 65H120.875ZM121.007 60.56C121.763 60.56 122.303 59.936 122.303 59.096C122.303 58.256 121.763 57.644 121.007 57.644C120.263 57.644 119.723 58.268 119.723 59.108C119.723 59.948 120.263 60.56 121.007 60.56ZM126.407 65.168C125.171 65.168 124.319 64.292 124.319 63.008C124.319 61.724 125.171 60.836 126.407 60.836C127.655 60.836 128.507 61.712 128.507 62.996C128.507 64.28 127.655 65.168 126.407 65.168ZM126.407 64.46C127.163 64.46 127.715 63.848 127.715 62.996C127.715 62.156 127.163 61.544 126.407 61.544C125.663 61.544 125.111 62.156 125.111 63.008C125.111 63.848 125.663 64.46 126.407 64.46Z"
      fill="black"
    />
    <path data-testid="chartLines" :class="$style.chartLines" d="M285 1L285 93" />
    <path data-testid="chartLines" :class="$style.chartLines" d="M172 1L172 93" />
    <path data-testid="chartLines" :class="$style.chartLines" d="M59 1L59 93" />
  </svg>
  <div v-else :class="$style.imageContainer">
    <img
      :class="$style.imageClass"
      loading="lazy"
      :src="noRoomDataImage"
      :alt="t('priceRoomDistribution.alternateNoDataImage')"
    />
  </div>
</template>
<script setup lang="ts">
import noRoomDataImage from '@/assets/noRoomData.png';
import { useI18n } from 'vue-i18n';

interface Props {
  dataFound: boolean;
}

withDefaults(defineProps<Props>(), {
  dataFound: true,
});

const { t } = useI18n();
</script>
<style lang="scss" module>
@use '@/styles/variables' as *;

.chartCurve {
  stroke: $color-teal-140;
  stroke-width: 2;
}

.chartPolygon {
  fill: var(--theme-color-primary);
}

.chartLines {
  stroke: $color-grey-70;
  stroke-width: 0.5;
}

.svgBox {
  fill: none;
}

.imageContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 168px;
  margin-top: $space-200;
  margin-bottom: $space-200;
}

.imageClass {
  width: 226px;
  height: 168px;
}
</style>
